import { Record as record } from 'immutable';

import Fare from './Fare';
import { construct, resolve } from '../helpers/LinkMapper';


const defaults = {
    outwardSingle: null,
    inboundSingle: null,
    return: null,
    totalPrice: null
};


class CheapestFares extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(CheapestFares, json, {
            outwardSingle: resolve.as(Fare),
            inboundSingle: resolve.as(Fare),
            return: resolve.as(Fare),
            totalPrice: resolve.with(Number)
        });
    }

    isCheapestFare (fare) {
        return (this.return && fare.id === this.return.id)
            || (this.outwardSingle && fare.id === this.outwardSingle.id)
            || (this.inboundSingle && fare.id === this.inboundSingle.id);
    }

    reverseSingles () {
        const outwardSingle = this.outwardSingle,
            inboundSingle = this.inboundSingle;

        return this
            .set('outwardSingle', inboundSingle)
            .set('inboundSingle', outwardSingle);
    }
}


export default CheapestFares;



// WEBPACK FOOTER //
// ./src/records/CheapestFares.js